module.exports = __webpack_public_path__ + "static/media/branch-icon.c9266df4.svg";